/**
 * Mountet das Bsport Widget mit Retry-Logik
 */
window.MountBsportWidget = function(config, repeat = 1) {
    if (repeat > 50) { return }
    if (!window.BsportWidget) {
        return setTimeout(() => {
            MountBsportWidget(config, repeat + 1)
        }, 100 * repeat || 1)
    }
    BsportWidget.mount(config);

    if (window.observeBsportWidget) {
        observeBsportWidget(config.parentElement);
    }
}

/**
 * Beobachtet Änderungen im Bsport Widget Container und aktualisiert Lenis Scroll
 */
window.observeBsportWidget = function(containerId) {
    const widgetContainer = document.getElementById(containerId);

    if (!widgetContainer) {
        console.warn(`Bsport widget container "${containerId}" not found`);
        return;
    }

    let resizeTimeout;

    const observer = new MutationObserver(() => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (window.lenis) {
                lenis.resize();
                console.log('Lenis resized after widget content change');
            }
        }, 200);
    });

    observer.observe(widgetContainer, {
        childList: true,
        subtree: true,
        attributes: true
    });

    console.log(`MutationObserver watching bsport widget "${containerId}" for changes`);
};
